<template>
    <div id="yxToast" class="yx-toast" :class="{'full-screen': mask}">
        <div class="main" :class="{'has-transition' : currentType.type != 'loading', show }">
            <img v-if="currentType.type =='fail'" src="@/static/img/error.png" />
            <img v-if="currentType.type =='success'" src="@/static/img/true.png" />
            <div v-if="currentType.type == 'loading'" class="loading-con">
                <div class="loading"></div>
            </div>
            <p v-html="title"></p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            type: "",
            show: false,
            iconList: [
                {
                    type: "none",
                },
                {
                    type: "success",
                },
                {
                    type: "fail",
                },
                {
                    type: "loading",
                }
            ],
            mask: true,
            duration: 1500,
            title: ""
        };
    },
    computed: {
        currentType() {
            let { iconList, type } = this;
            let activeType = null;
            iconList.forEach(item => {
                if (item.type == type) {
                    activeType = item;
                }
            });
            return activeType;
        }
    },
    methods: {
        clearExistElement() {
            let existEle = document.querySelector("#yxToast");
            if (existEle) {
                document.body.removeChild(existEle);
            }
        }
    },
    mounted() {
        this.clearExistElement();
        this.show = true;
        if (this.currentType.type != "loading") {
            setTimeout(() => {
                this.show = false;
                setTimeout(() => {
                    this.$el.parentNode.removeChild(this.$el);
                }, 300);
            }, this.duration);
        }
    }
};
</script>

<style scoped lang="scss">
.yx-toast {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    &.full-screen {
        width: 100%;
        height: 100%;
    }
    .main {
        padding: 1.2rem 1rem;
				min-width: 20%;
        border-radius: 0.4rem;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        font-size: 1.15rem;
        letter-spacing: 0.1rem;
        position: fixed;
        top: 55%;
        left: 50%;
        transform: translate(-50%, -50%);
        opacity: 0;
        &.has-transition {
            transition: all 0.3s ease;
        }
        &.show {
            opacity: 1;
            top: 50%;
        }
        img {
            display: block;
            max-width: 35px;
            width: 50%;
            margin: 0 auto 0.7rem auto;
        }
        p {
            text-align: center;
        }
        .loading-con {
            width: 2rem;
            height: 2rem;
            margin: 0.7rem auto;
            .loading {
                width: 1.5rem;
                height: 1.5rem;
                margin: auto;
                border: solid #fff 0.1rem;
                border-top: none;
                border-left: none;
                border-radius: 50%;
                animation: loading 1s infinite;
                animation-timing-function: linear;
                @keyframes loading {
                    0% {
                        transform: rotate(0deg);
                    }
                    50% {
                        transform: rotate(180deg);
                    }
                    100% {
                        transform: rotate(360deg);
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/yx-toast/index.vue